import JwtService from '@/core/services/jwt.service'
import { getDataFromLocalStorage } from "@/utils/utils";

export default {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
  isCraftsmanLogged: !!getDataFromLocalStorage('isCraftsmanLogged'),
  locales: [],
}
